import { PayloadAction } from '@reduxjs/toolkit';
import { message } from 'antd';
import { AxiosResponse } from 'axios';
import { put, takeLatest } from 'redux-saga/effects';
import {
  fetchAllAgencies,
  fetchAllAgenciesFailure,
  fetchAllAgenciesSuccess,
  getAllColumnsWithDistinctValueRequest,
} from 'redux/slice/admin/onboarding/agency/AgencyList.slice';
import { setUniqueValues } from 'redux/slice/filter/Filter.slice';
import { yucollectAdmin } from 'services/api/endPoints';
import { HTTPClient } from 'services/api/http-client';

// Saga for fetching allocation records by ID
function* fetchAllAgenciesSaga(action: PayloadAction<any>) {
  try {
    const page = action.payload.page ?? 0;
    const size = action.payload.size ?? 10;
    const searchText = action.payload.searchText ?? null;
    const columns = action.payload.columns;
    const URL =
      `${yucollectAdmin.GET_ALL_AGENCIES}?page=${page}&size=${size}` +
      (searchText ? `&searchValue=${searchText}` : '');
    const response: AxiosResponse<any> = yield HTTPClient.PostRequest(URL, {
      columns,
    });
    yield put(fetchAllAgenciesSuccess(response.data));
    message.success(response.data.message);
  } catch (error: any) {
    yield put(fetchAllAgenciesFailure(error?.message));
    message.error('Failed to fetch allocation records');
  }
}

function* getAllColumnsWithDistinctValue(action: any) {
  try {
    const columnName = action.payload.columnName ?? '';
    const URL = `${yucollectAdmin.GET_UNIQUE_VALUES_BY_COLUMN(columnName)}`;
    const response: AxiosResponse<any> = yield HTTPClient.GetRequest(URL);
    yield put(setUniqueValues(response.data));
  } catch (error: any) {}
}

export function* watchAgencyListSaga() {
  yield takeLatest(fetchAllAgencies.type, fetchAllAgenciesSaga);
  yield takeLatest(
    getAllColumnsWithDistinctValueRequest.type,
    getAllColumnsWithDistinctValue
  );
}
